import React, { Component } from "react";
import {
  View,
  Image,
  TouchableOpacity,
  FlatList,
  Animated,
  Dimensions,
  Linking,
  AppState,
  ScrollView,
  TouchableWithoutFeedback,
} from "react-native";
import { Modal } from "react-native-web";
import { icons } from "../theme/icons";
import {
  appStyles,
  componentStyles,
  requestInfoStyles,
  profileStyles,
  walletStyles,
  viewCartStyles,
  orderInfoStyles,
  customerLocationStyles,
  loginStyles,
} from "../theme/styles";
import TextView from "../components/TextView";
import LinearGradient from "react-native-linear-gradient";
import {
  blueDarkColor,
  blueLightColor,
  greenLightColor,
  greenDarkColor,
  darkColor,
  yellowLightColor,
  yellowDarkColor,
  redColor,
} from "../theme/colors";
import SessionItem from "../components/SessionItem";
import {
  getMyOrderInfoRequest,
  reasonsRequest,
  cancelOrderRequest,
  arrivedRequest,
  hamradRequest,
  supportNumberRequest,
  endOrderRequest,
  rateOrderRequest,
  endSessionRequest,
  hamradSessionRequest,
  startSessionRequest,
  arrivedSessionRequest,
  askConditionRequest,
  cancellSessionRequest,
} from "../utils/api";
import Waiting from "../components/Waiting";
import {
  getStatus,
  persianNumber,
  getStatusColor,
  priceString,
  showPrompt,
  showMessage,
  getError,
  getStatusPay,
  getNumber,
} from "../utils/utils";

var { width, height } = Dimensions.get("window");
import { hp, wp } from "../utils/responsive";
import CedarMaps from "@cedarstudios/react-cedarmaps";
import Button from "../components/Button";
import DialogPrompt from "../components/DialogPrompt";
import EditText from "../components/EditText";
import ImageZoom from "react-native-image-pan-zoom";
import * as Location from "expo-location";

const LATITUDE = 35.724566;
const LONGITUDE = 51.367788;
export default class OrderInfoScreen extends Component {
  _timerId = 0;
  intervalId = 0;

  constructor(props) {
    super(props);
    this.state = {
      session: [],
      appState: "",
      comment: "",
      selectedImage: "",
      galleryModal: false,
      images: [],
      showEndSession: false,
      showStartSession: false,
      currentSession: null,
      satisfy: "",
      isfirstSession: true,
      showSession: false,
      rateModal: false,
      reasonModal: false,
      showHamrad: false,
      reasons: [],
      walletBalance: 0,
      waiting: true,
      expanded: false,
      selectedReason: [],
      animation: new Animated.Value(0),
      minHeight: 0,
      askModal: false,
      maxHeight: height - 70,
      info_order: null,
      order_details: [],
      info_servant: null,
      latitude: 0,
      longitude: 0,
      region: [LONGITUDE, LATITUDE],
      expert: [],
      customer: [],
    };
    this.scrollView = null;
  }

  _keyExtractor = (item, index) => index.toString();

  renderOrderRow({ item, index }) {
    return (
      <View
        style={[
          appStyles.rowAround,
          {
            width: width - 50,
            borderBottomColor: "#F8F8F8",
            margin: 5,
            paddingBottom: 5,
            borderBottomWidth: 1,
          },
        ]}
      >
        <TextView style={[appStyles.textCenter, { color: "#31CF75" }]}>
          {priceString(item.price)}
        </TextView>
        <TextView style={[appStyles.textCenter, { color: "#31CF75" }]}>
          {persianNumber(item.number)}
        </TextView>
        <TextView
          style={{
            width: (width - 60) / 4,
            textAlign: "center",
            fontSize: 12,
            color: "#31CF75",
          }}
        >
          {item.title}
        </TextView>
        <View
          style={{
            backgroundColor: "#31CF75",
            borderRadius: 5,
            width: 25,
            height: 25,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TextView style={{ fontSize: 12, color: "white" }}>
            {"" + (index + 1)}
          </TextView>
        </View>
      </View>
    );
  }

  renderPreOrderRow({ item, index }) {
    return (
      <View
        style={[
          appStyles.rowAround,
          {
            alignSelf: "center",
            width: wp(85),
            paddingBottom: 5,
            borderBottomColor: "#F8F8F8",
            borderBottomWidth: 1,
          },
        ]}
      >
        <TextView style={appStyles.textCenter}>
          {priceString(item.number * item.price)}
        </TextView>
        <TextView style={appStyles.textCenter}>
          {persianNumber(item.number)}
        </TextView>
        <TextView style={appStyles.textCenter}>
          {priceString(item.price)}
        </TextView>
        <TextView
          style={{
            width: wp(18),
            color: "#4D4C53",
            textAlign: "center",
            fontSize: 12,
          }}
        >
          {item.title}
        </TextView>
      </View>
    );
  }

  renderFooter({ item, index }) {
    return (
      <View>
        {this.state.images != null && this.state.images.length > 0 ? (
          <View>
            <TouchableOpacity
              style={[componentStyles.editButtonWraper, { width: wp(30) }]}
              onPress={() => {
                this.setState({
                  galleryModal: true,
                  selectedImage: this.state.images[0].link,
                });
              }}
            >
              <TextView
                style={{
                  color: "white",
                  fontSize: 11,
                  textAlign: "center",
                  margin: 2,
                }}
              >
                {this.state.images[0].title}
              </TextView>
            </TouchableOpacity>
          </View>
        ) : null}
        <View
          style={[
            appStyles.rowAround,
            { width: width - 60, marginTop: 20, paddingBottom: 10 },
          ]}
        >
          <View style={appStyles.center}>
            <TextView style={{ margin: 5, color: "#4D4C53" }}>
              مبلغ پرداختی
            </TextView>
            <TextView style={appStyles.textCenter}>
              {priceString(this.state.info_order.price_pay)}
            </TextView>
          </View>
          <View style={viewCartStyles.lineHorz} />
          <View style={appStyles.center}>
            <TextView style={{ margin: 5, color: "#4D4C53" }}>
              هزینه رفت و آمد
            </TextView>
            <TextView style={appStyles.textCenter}>
              {priceString(this.state.info_order.price_sweep)}
            </TextView>
          </View>
          <View style={viewCartStyles.lineHorz} />

          <View style={appStyles.center}>
            <TextView style={{ margin: 5, color: "#4D4C53" }}>
              جمع فاکتور
            </TextView>
            <TextView style={appStyles.textCenter}>
              {priceString(this.state.info_order.price_factor)}
            </TextView>
          </View>
        </View>
      </View>
    );
  }

  renderHeader() {
    return (
      <View style={requestInfoStyles.headerWraper}>
        <TextView style={appStyles.textCenter}>پرداخت</TextView>
        <TextView style={appStyles.textCenter}>تاریخ</TextView>
        <TextView style={appStyles.textCenter}>نام سفیر سلامت</TextView>
        <TextView style={appStyles.textCenter}>جلسه</TextView>
      </View>
    );
  }

  renderReasonRow({ item }) {
    var selected = this.state.selectedReason.filter((it) => it.id === item.id);
    return (
      <TouchableOpacity
        style={[
          selected.length > 0
            ? { borderWidth: 1, borderColor: "#FF4B47", borderRadius: 8 }
            : { borderWidth: 1, borderColor: "#F8F8F8", borderRadius: 8 },
          {
            width: wp(40),
            margin: 5,
            padding: 5,
            alignItems: "center",
            justifyContent: "center",
          },
        ]}
        onPress={() => {
          var reasons = this.state.selectedReason;
          if (selected.length > 0) {
            reasons = this.state.selectedReason.filter(
              (it) => it.id !== item.id
            );
          } else {
            reasons.push(item);
          }
          this.setState({
            selectedReason: reasons,
          });
        }}
      >
        <TextView
          style={[
            {
              width: wp(30),
              textAlign: "center",
              color: selected.length > 0 ? "#FF4B47" : "#4D4C53",
            },
          ]}
        >
          {item.reason}
        </TextView>
      </TouchableOpacity>
    );
  }

  renderArrivedHeader() {
    if (this.state.info_order != null) {
      return (
        <View>
          <TextView
            style={{
              textAlign: "center",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            {this.state.info_order.title_service}
          </TextView>
          <View style={appStyles.rowBetween}>
            <View
              style={[
                componentStyles.statusWraper,
                {
                  backgroundColor: getStatusColor(
                    false,
                    this.state.info_order.status_order,
                    []
                  ),
                },
              ]}
            >
              <TextView
                style={{
                  color: "white",
                  fontSize: 12,
                }}
              >
                {getStatus(false, this.state.info_order.status_order, [])}
              </TextView>
            </View>
            <View
              style={[
                componentStyles.statusWraper,
                { backgroundColor: greenDarkColor },
              ]}
            >
              <TextView style={{ color: "white", fontSize: 12 }}>
                وضعیت پرداخت : {getStatusPay(this.state.info_order.status_pay)}
              </TextView>
            </View>
          </View>
          <View style={orderInfoStyles.lineDark} />
          <View style={[appStyles.rowBetween, { marginBottom: 10 }]}>
            <TextView style={{ fontSize: 10, color: darkColor }}>
              تاریخ سفارش : {persianNumber(this.state.info_order.date_create)}
            </TextView>
            <TextView style={{ fontSize: 10, color: darkColor }}>
              شماره سفارش : {this.state.info_order.trackingcode}
            </TextView>
          </View>
          <View style={appStyles.rowAround}>
            <View style={appStyles.center}>
              <TextView style={{ margin: 5 }}>جمع فاکتور</TextView>
              <TextView style={appStyles.textCenter}>
                {priceString(this.state.info_order.price_pay)} تومان
              </TextView>
            </View>
            <View style={viewCartStyles.lineHorz} />
            <View style={appStyles.center}>
              <TextView style={{ margin: 5 }}> بیمه</TextView>
              <TextView style={appStyles.textCenter}>
                {priceString(this.state.info_order.price_insurance)} تومان
              </TextView>
            </View>
            <View style={viewCartStyles.lineHorz} />

            <View style={appStyles.center}>
              <TextView style={{ margin: 5 }}>هزینه رفت و آمد</TextView>
              <TextView style={appStyles.textCenter}>
                {priceString(this.state.info_order.price_sweep)} تومان
              </TextView>
            </View>
          </View>
          {this.state.showSession ? (
            <View style={orderInfoStyles.lineDark} />
          ) : null}
          {this.state.showSession ? (
            <View style={appStyles.rowAround}>
              <View style={appStyles.center}>
                <TextView style={{ margin: 5 }}>مبلغ مانده</TextView>
                <TextView style={appStyles.textCenter}>
                  {priceString(this.state.info_order.remaindprice_order)} تومان
                </TextView>
              </View>
              <View style={viewCartStyles.lineHorz} />
              <View style={appStyles.center}>
                <TextView style={{ margin: 5 }}>هزینه یک جلسه</TextView>
                <TextView style={appStyles.textCenter}>
                  {priceString(this.state.info_order.onesession_price)} تومان
                </TextView>
              </View>
            </View>
          ) : null}
          <View style={orderInfoStyles.lineDark} />
          {!this.state.showSession ? (
            <View style={appStyles.rowAround}>
              <TextView style={appStyles.textCenter}>قیمت</TextView>
              <TextView style={appStyles.textCenter}>تعداد</TextView>
              <TextView style={appStyles.textCenter}>عنوان خدمت</TextView>
              <TextView style={appStyles.textCenter}>ردیف</TextView>
            </View>
          ) : (
            <View>
              <View style={appStyles.rowAround}>
                <TextView style={appStyles.textCenter}>وضعیت</TextView>
                <TextView style={appStyles.textCenter}>نوع پرداخت</TextView>
                <TextView style={appStyles.textCenter}>تاریخ انجام</TextView>
                <TextView style={appStyles.textCenter}>جلسه</TextView>
              </View>
            </View>
          )}
          <View style={orderInfoStyles.lineDark} />
        </View>
      );
    } else {
      return <View />;
    }
  }

  renderNormalHeader() {
    if (this.state.info_order != null) {
      return (
        <View>
          <View
            style={[appStyles.rowBetween, { marginBottom: 10, marginTop: 10 }]}
          >
            <View
              style={[
                componentStyles.statusWraper,
                {
                  backgroundColor: getStatusColor(
                    false,
                    this.state.info_order.status_order,
                    []
                  ),
                },
              ]}
            >
              <TextView style={{ color: "white", fontSize: 12 }}>
                وضعیت :{" "}
                {getStatus(false, this.state.info_order.status_order, [])}
              </TextView>
            </View>
            <TextView style={[appStyles.rightText, { fontSize: 12 }]}>
              وضعیت پرداخت : {getStatusPay(this.state.info_order.status_pay)}
            </TextView>
          </View>
          <View style={appStyles.rowBetween}>
            <TextView style={{ fontSize: 10 }}>
              تاریخ سفارش : {persianNumber(this.state.info_order.date_create)}
            </TextView>

            <TextView style={[appStyles.rightText, { fontSize: 10 }]}>
              شماره سفارش : {this.state.info_order.trackingcode}
            </TextView>
          </View>
          <View style={orderInfoStyles.lineDark} />
          <View
            style={{
              alignItems: "center",
              marginRight: 10,
              justifyContent: "center",
            }}
          >
            <TextView style={orderInfoStyles.customerInfoText}>
              نام بیمار : {this.state.info_order.name}
            </TextView>
            <View style={orderInfoStyles.lineLight} />
            <TouchableOpacity style={{ marginTop: 10 }}>
              <TextView
                style={[orderInfoStyles.customerInfoText, { marginTop: 0 }]}
              >
                شماره تماس : {persianNumber(this.state.info_order.cellphone)}
              </TextView>
            </TouchableOpacity>
            <View style={orderInfoStyles.lineLight} />
            <TextView style={orderInfoStyles.customerInfoText}>
              آدرس : {this.state.info_order.address}
            </TextView>
            {this.state.info_order.comment != null ? (
              <TextView style={orderInfoStyles.customerInfoText}>
                {this.state.info_order.comment}
              </TextView>
            ) : null}
          </View>
          <View style={orderInfoStyles.lineDark} />
          <View style={appStyles.rowAround}>
            <View style={appStyles.center}>
              <TextView style={{ margin: 5 }}>جمع فاکتور</TextView>
              <TextView style={appStyles.textCenter}>
                {priceString(this.state.info_order.price_pay)} تومان
              </TextView>
            </View>
            <View style={viewCartStyles.lineHorz} />
            <View style={appStyles.center}>
              <TextView style={{ margin: 5 }}>بیمه</TextView>
              <TextView style={appStyles.textCenter}>
                {priceString(this.state.info_order.price_insurance)} تومان
              </TextView>
            </View>
            <View style={viewCartStyles.lineHorz} />
            <View style={appStyles.center}>
              <TextView style={{ margin: 5 }}>هزینه رفت و آمد</TextView>
              <TextView style={appStyles.textCenter}>
                {priceString(this.state.info_order.price_sweep)} تومان
              </TextView>
            </View>
          </View>
          {this.state.showSession ? (
            <View style={orderInfoStyles.lineDark} />
          ) : null}
          {this.state.showSession ? (
            <View style={appStyles.rowAround}>
              <View style={appStyles.center}>
                <TextView style={{ margin: 5 }}>مبلغ مانده</TextView>
                <TextView style={appStyles.textCenter}>
                  {priceString(this.state.info_order.remaindprice_order)} تومان
                </TextView>
              </View>
              <View style={viewCartStyles.lineHorz} />
              <View style={appStyles.center}>
                <TextView style={{ margin: 5 }}>هزینه یک جلسه</TextView>
                <TextView style={appStyles.textCenter}>
                  {priceString(this.state.info_order.onesession_price)} تومان
                </TextView>
              </View>
            </View>
          ) : null}
          <View style={orderInfoStyles.lineDark} />
          {!this.state.showSession ? (
            <View style={appStyles.rowAround}>
              <TextView style={appStyles.textCenter}>قیمت</TextView>
              <TextView style={appStyles.textCenter}>تعداد</TextView>
              <TextView style={appStyles.textCenter}>عنوان خدمت</TextView>
              <TextView style={appStyles.textCenter}>ردیف</TextView>
            </View>
          ) : (
            <View>
              <TextView style={{ color: "#BBBBBB", textAlign: "center" }}>
                وضعیت درخواست{" "}
                {getStatus(false, this.state.info_order.status_order, [])}
              </TextView>
              <ScrollView
                ref={(ref) => (this.scrollView = ref)}
                onContentSizeChange={() =>
                  this.scrollView != null &&
                  this.scrollView.scrollToEnd({ animated: false })
                }
                horizontal
              >
                <View
                  style={{
                    height: wp(16),
                    width: wp(85),
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: 50,
                    marginTop: 10,
                    marginBottom: 10,
                  }}
                >
                  <FlatList
                    horizontal={true}
                    showsHorizontalScrollIndicator={false}
                    inverted={true}
                    data={this.state.order_details[0].sessions}
                    renderItem={this.renderSessionHeaderRow.bind(this)}
                    keyExtractor={this._keyExtractor}
                  />
                </View>
              </ScrollView>
              <View style={appStyles.rowAround}>
                <TextView style={appStyles.textCenter}>وضعیت</TextView>
                <TextView style={appStyles.textCenter}>نوع پرداخت</TextView>
                <TextView style={appStyles.textCenter}>تاریخ انجام</TextView>
                <TextView style={appStyles.textCenter}>جلسه</TextView>
              </View>
            </View>
          )}
        </View>
      );
    } else {
      return <View />;
    }
  }

  renderOrderHeader() {
    return (
      <View style={requestInfoStyles.headerWraper}>
        <TextView style={appStyles.textCenter}>جمع کل</TextView>
        <TextView style={appStyles.textCenter}>تعداد</TextView>
        <TextView style={appStyles.textCenter}>قیمت</TextView>
        <TextView style={appStyles.textCenter}>عنوان خدمت</TextView>
      </View>
    );
  }

  renderPreOrderHeader() {
    return (
      <View>
        <TextView style={{ margin: 10, color: "#31CF75", textAlign: "center" }}>
          درخواست کننده : {this.state.info_order.name}
        </TextView>
        <View style={[appStyles.rowAround]}>
          <View style={[appStyles.center, { marginRight: 15 }]}>
            <TextView style={{ margin: 5, color: "#4D4C53" }}>
              تاریخ سفارش
            </TextView>
            <TextView style={{ margin: 5, color: "#4D4C53" }}>
              {persianNumber(this.state.info_order.date_create)}
            </TextView>
          </View>
          <View style={appStyles.center}>
            <TextView style={{ margin: 5, color: "#4D4C53" }}>
              شماره سفارش
            </TextView>
            <TextView style={{ margin: 5, color: "#4D4C53" }}>
              {this.state.info_order.trackingcode}
            </TextView>
          </View>
        </View>
        <View style={orderInfoStyles.lineDark} />
        <View
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: 10,
          }}
        >
          <Image
            source={icons["pin"]}
            style={{ width: 35, height: 35, resizeMode: "contain" }}
          />
          <TextView
            style={{
              textAlign: "center",
              color: "#4D4C53",
              marginTop: 5,
            }}
          >
            {this.state.info_order.address}
          </TextView>
          {this.state.info_order.comment != null ? (
            <TextView
              style={{
                textAlign: "center",
                color: "#4D4C53",
                marginTop: 5,
              }}
            >
              {this.state.info_order.comment}
            </TextView>
          ) : null}
        </View>
        <View style={orderInfoStyles.lineDark} />
        <View
          style={[appStyles.rowAround, { width: wp(80), marginLeft: wp(5) }]}
        >
          <View style={appStyles.center}>
            <TextView style={{ margin: 5 }}>جمع فاکتور</TextView>
            <TextView style={appStyles.textCenter}>
              {priceString(this.state.info_order.price_pay)} تومان
            </TextView>
          </View>
          <View style={viewCartStyles.lineHorz} />
          <View style={appStyles.center}>
            <TextView style={{ margin: 5 }}>بیمه </TextView>
            <TextView style={appStyles.textCenter}>
              {priceString(this.state.info_order.price_insurance)} تومان
            </TextView>
          </View>
          <View style={viewCartStyles.lineHorz} />
          <View style={appStyles.center}>
            <TextView style={{ margin: 5 }}>هزینه رفت و آمد</TextView>
            <TextView style={appStyles.textCenter}>
              {priceString(this.state.info_order.price_sweep)} تومان
            </TextView>
          </View>
        </View>
        {this.state.showSession ? (
          <View style={orderInfoStyles.lineDark} />
        ) : null}
        {this.state.showSession ? (
          <View style={appStyles.rowAround}>
            <View style={appStyles.center}>
              <TextView style={{ margin: 5 }}>مبلغ مانده</TextView>
              <TextView style={appStyles.textCenter}>
                {priceString(this.state.info_order.remaindprice_order)} تومان
              </TextView>
            </View>
            <View style={viewCartStyles.lineHorz} />
            <View style={appStyles.center}>
              <TextView style={{ margin: 5 }}>هزینه یک جلسه</TextView>
              <TextView style={appStyles.textCenter}>
                {priceString(this.state.info_order.onesession_price)} تومان
              </TextView>
            </View>
          </View>
        ) : null}
        <View style={orderInfoStyles.lineDark} />
        <View style={[requestInfoStyles.headerWraper, { marginTop: 5 }]}>
          <TextView style={appStyles.textCenter}>جمع کل</TextView>
          <TextView style={appStyles.textCenter}>تعداد</TextView>
          <TextView style={appStyles.textCenter}>قیمت</TextView>
          <TextView style={appStyles.textCenter}>عنوان خدمت</TextView>
        </View>
      </View>
    );
  }

  renderSessionRow({ item, index }) {
    if (item.status_servant != null) {
      return <SessionItem data={item} />;
    } else {
      return <View />;
    }
  }

  renderSessionHeaderRow({ item, index }) {
    return (
      <View
        style={[
          {
            width: wp(13),
            height: wp(13),
            borderRadius: 8,
            margin: 5,
            backgroundColor: item.status_servant == null ? "white" : "#31CF75",
            borderWidth: 2,
            borderColor: item.status_servant == null ? "#C5C5C5" : "#31CF75",
          },
          appStyles.center,
        ]}
      >
        <TextView
          style={{
            textAlign: "center",
            fontSize: 12,
            color: item.status_servant == null ? "#C5C5C5" : "white",
          }}
        >
          جلسه
        </TextView>
        <TextView
          style={{
            textAlign: "center",
            color: item.status_servant == null ? "#C5C5C5" : "white",
          }}
        >
          {getNumber(item.session_number)}
        </TextView>
      </View>
    );
  }

  render() {
    if (this.state.info_order != null) {
      if (this.state.info_order.status_order === "end") {
        return this.normalUI();
      } else if (this.state.info_order.status_order === "cancelled") {
        return this.normalUI();
      } else if (this.state.info_order.status_order === "arrived") {
        return this.arrivedUI();
      } else if (this.state.info_order.status_order === "getservant") {
        if (this.state.showSession) {
          if (this.state.currentSession != null) {
            if (this.state.currentSession.status_servant === "start") {
              return this.doingUI();
            } else if (this.state.currentSession.status_servant === "arrived") {
              return this.arrivedUI();
            } else {
              if (this.state.isfirstSession) {
                return this.preFactorUI();
              } else {
                return this.normalUI();
              }
            }
          } else {
            return this.normalUI();
          }
        } else {
          if (this.state.info_order.taxi == null) {
            return this.preFactorUI();
          } else {
            return this.doingUI();
          }
        }
      } else {
        return <View />;
      }
    } else {
      if (this.state.waiting) {
        return (
          <View style={{ flex: 1 }}>
            <Waiting waiting={this.state.waiting} />
          </View>
        );
      } else {
        return <View />;
      }
    }
  }

  doingUI() {
    const { Marker, Layer } = CedarMaps.getReactMapboxGl();
    return (
      <View style={{ flex: 1 }}>
        <View style={appStyles.toolbarWraper}>
          {this.state.info_order != null &&
          (this.state.info_order.status_order === "arrived" ||
            this.state.info_order.status_order === "getservant") ? (
            <TouchableOpacity
              style={appStyles.row}
              onPress={() => {
                if (this.state.showSession) {
                  showPrompt(
                    "لغو جلسه",
                    "آیا میخواهید جلسه جاری را لغو نمایید؟",
                    () => {
                      this.setState({
                        waiting: true,
                      });
                      cancellSessionRequest(
                        this.state.currentSession.id_session,
                        (isConnect, response) => {
                          if (isConnect && response.isSuccess) {
                            this.setState({
                              waiting: true,
                            });
                            this.getData();
                          } else {
                            showMessage("", response.message);
                          }
                        }
                      );
                    }
                  );
                } else {
                  this.setState({
                    reasonModal: true,
                  });
                }
              }}
            >
              <Image
                source={icons["cancel"]}
                style={[
                  appStyles.toolbarIcon,
                  { marginRight: 10, width: 15, height: 15 },
                ]}
              />
              <TextView style={{ fontSize: 12 }}>
                {this.state.showSession ? "لغو جلسه" : "لغو سفارش"}
              </TextView>
            </TouchableOpacity>
          ) : (
            <View />
          )}
          <TextView style={appStyles.toolbarTitle}>رسید نهایی</TextView>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.goBack();
            }}
          >
            <Image source={icons["back"]} style={appStyles.backIcon} />
          </TouchableOpacity>
        </View>
        <View
          style={[
            {
              height: hp(93),
              borderTopLeftRadius: 40,
              borderTopRightRadius: 40,
            },
          ]}
        >
          <CedarMaps
            token="de1f4bf85b1e70f435a36cc27a5a61075793a194"
            zoomLevel={15}
            center={this.state.customer}
            containerStyle={{
              marginTop: 15,
              overflow: "hidden",
              height: hp(40),
              borderTopLeftRadius: 50,
              borderTopRightRadius: 50,
            }}
          >
            <Marker coordinates={this.state.customer} anchor="bottom">
              <Image
                source={icons["onmappin"]}
                style={{ width: 50, height: 50, resizeMode: "contain" }}
              />
            </Marker>
            <Marker coordinates={this.state.expert} anchor="bottom">
              <Image
                source={icons["mypin"]}
                style={{ width: 50, height: 50, resizeMode: "contain" }}
              />
            </Marker>
          </CedarMaps>
          <View
            style={{
              position: "absolute",
              left: 10,
              right: 10,
              top: 5,
              backgroundColor: "white",
              borderRadius: 5,
              padding: 10,
            }}
          >
            <TextView style={{ textAlign: "center" }}>
              {this.state.info_order.address}
            </TextView>
          </View>
          <TouchableOpacity
            style={{
              padding: 10,
              backgroundColor: "white",
              borderRadius: 5,
              position: "absolute",
              right: 10,
              top: 70,
            }}
            onPress={() => {
              if (
                this.state.customer != null &&
                this.state.customer.length > 1
              ) {
                Linking.openURL(
                  "geo:" +
                    this.state.customer[1] +
                    "," +
                    this.state.customer[0] +
                    "?q=" +
                    this.state.customer[1] +
                    "," +
                    this.state.customer[0]
                );
              }
            }}
          >
            <Image
              source={icons["route"]}
              style={{ width: 20, height: 20, resizeMode: "contain" }}
            />
          </TouchableOpacity>
          <LinearGradient
            colors={[blueDarkColor, blueLightColor]}
            style={[profileStyles.wraper, { height: hp(53) }]}
          >
            <View style={walletStyles.walletBox}>
              <View style={[requestInfoStyles.boxWraper, { paddingTop: 10 }]}>
                <TextView style={{ margin: 5 }}>
                  {this.state.info_order.name}
                </TextView>
                <TextView
                  style={{ margin: 5, color: "#4D4C53", fontSize: hp(1.7) }}
                >
                  (مددجو)
                </TextView>
                <TextView
                  style={{ margin: 5, color: "#4D4C53", fontSize: hp(1.7) }}
                >
                  شماره سفارش : {this.state.info_order.trackingcode}
                </TextView>
              </View>
            </View>
            <View
              style={[
                appStyles.bottomView,
                appStyles.rowBetween,
                {
                  minHeight: hp(20),
                  alignItems: "flex-start",
                  paddingTop: 15,
                },
              ]}
            >
              <TouchableOpacity
                activeOpacity={0.5}
                onPress={() => {
                  this.setState({
                    waiting: true,
                  });
                  if (this.state.showSession) {
                    arrivedSessionRequest(
                      this.state.currentSession.id_session,
                      (isConnect, response) => {
                        if (isConnect && response.isSuccess) {
                          this.setState({
                            waiting: true,
                          });
                          this.getData();
                        } else {
                          this.setState({
                            waiting: false,
                          });
                          showMessage("", getError(response));
                        }
                      }
                    );
                  } else {
                    arrivedRequest(
                      this.props.route.params.data.id,
                      (isConnect, response) => {
                        if (isConnect && response.isSuccess) {
                          this.setState({
                            waiting: true,
                          });
                          this.getData();
                        } else {
                          this.setState({
                            waiting: false,
                          });
                          showMessage("", getError(response));
                        }
                      }
                    );
                  }
                }}
              >
                <LinearGradient
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                  colors={[blueLightColor, blueDarkColor]}
                  style={[
                    componentStyles.gradinatButton,
                    {
                      width: wp(45),
                      borderRadius: hp(8) / 2,
                      height: hp(8),
                    },
                  ]}
                >
                  <TextView style={componentStyles.requestText}>
                    رسیدم به خانه
                  </TextView>
                  <Image
                    source={icons["arrived"]}
                    style={{
                      width: wp(8),
                      height: wp(8),
                      resizeMode: "contain",
                      marginRight: 15,
                    }}
                  />
                </LinearGradient>
              </TouchableOpacity>
              <TouchableOpacity
                activeOpacity={0.5}
                onPress={() => {
                  Linking.openURL("tel:" + this.state.info_order.cellphone);
                }}
              >
                <LinearGradient
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                  colors={[greenLightColor, greenDarkColor]}
                  style={[
                    componentStyles.gradinatButton,
                    {
                      width: wp(45),
                      borderRadius: hp(8) / 2,
                      height: hp(8),
                    },
                  ]}
                >
                  <TextView style={componentStyles.requestText}>
                    تماس با بیمار
                  </TextView>
                  <Image
                    source={icons["call"]}
                    style={{
                      width: wp(8),
                      height: wp(8),
                      resizeMode: "contain",
                      marginRight: 15,
                    }}
                  />
                </LinearGradient>
              </TouchableOpacity>
            </View>
          </LinearGradient>
        </View>
        <Waiting waiting={this.state.waiting} />
        {this.renderCommonComponent()}
      </View>
    );
  }

  arrivedUI() {
    return (
      <View style={{ flex: 1 }}>
        <View style={appStyles.toolbarWraper}>
          <TouchableOpacity
            style={{ backgroundColor: redColor, borderRadius: 10, padding: 5 }}
            onPress={() => {
              this.setState({
                askModal: true,
              });
            }}
          >
            <TextView style={{ color: "white" }}>شرایط اضطراری</TextView>
          </TouchableOpacity>
          <TextView style={appStyles.toolbarTitle}>رسیدم به خانه</TextView>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.goBack();
            }}
          >
            <Image source={icons["back"]} style={appStyles.backIcon} />
          </TouchableOpacity>
        </View>
        <LinearGradient
          colors={[blueDarkColor, blueLightColor]}
          style={orderInfoStyles.arrivedWraper}
        >
          <View
            style={{
              backgroundColor: "white",
              borderRadius: 15,
              width: wp(90),
              padding: 5,
            }}
          >
            {!this.state.showSession ? (
              <FlatList
                data={this.state.order_details}
                ListHeaderComponent={this.renderArrivedHeader.bind(this)}
                renderItem={this.renderOrderRow.bind(this)}
                ListFooterComponent={this.renderBottom.bind(this)}
                keyExtractor={this._keyExtractor}
              />
            ) : (
              <FlatList
                data={this.state.order_details[0].sessions}
                ListHeaderComponent={this.renderArrivedHeader.bind(this)}
                renderItem={this.renderSessionRow.bind(this)}
                ListFooterComponent={this.renderBottom.bind(this)}
                keyExtractor={this._keyExtractor}
              />
            )}
          </View>
          <View
            style={[
              appStyles.bottomView,
              appStyles.rowBetween,
              {
                minHeight: hp(17),
                alignItems: "flex-start",
                paddingTop: 15,
              },
            ]}
          >
            <TouchableOpacity
              activeOpacity={0.5}
              onPress={() => {
                this.setState({
                  waiting: true,
                });
                supportNumberRequest((isConnect, response) => {
                  this.setState({
                    waiting: false,
                  });
                  if (isConnect && response.isSuccess) {
                    Linking.openURL("tel:" + response.data.support_number);
                  }
                });
              }}
            >
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={[yellowLightColor, yellowDarkColor]}
                style={[
                  componentStyles.gradinatButton,
                  {
                    width: wp(45),
                    borderRadius: hp(8) / 2,
                    height: hp(8),
                  },
                ]}
              >
                <TextView style={componentStyles.requestText}>
                  تماس با پشتیبانی
                </TextView>
                <Image
                  source={icons["support"]}
                  style={{
                    width: wp(8),
                    height: wp(8),
                    resizeMode: "contain",
                    tintColor: "white",
                    marginRight: 15,
                  }}
                />
              </LinearGradient>
            </TouchableOpacity>
            <TouchableOpacity
              activeOpacity={0.5}
              onPress={() => {
                if (this.state.showSession) {
                  this.setState({
                    showEndSession: true,
                  });
                } else {
                  this.setState({
                    rateModal: true,
                  });
                }
              }}
            >
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={[greenLightColor, greenDarkColor]}
                style={[
                  componentStyles.gradinatButton,
                  {
                    width: wp(45),
                    borderRadius: hp(8) / 2,
                    height: hp(8),
                  },
                ]}
              >
                <TextView style={componentStyles.requestText}>
                  {this.state.showSession ? "پایان جلسه" : "پایان خدمت"}
                </TextView>
                <Image
                  source={icons["finish"]}
                  style={{
                    width: wp(8),
                    height: wp(8),
                    resizeMode: "contain",
                    marginRight: 15,
                  }}
                />
              </LinearGradient>
            </TouchableOpacity>
          </View>
        </LinearGradient>
        <Waiting waiting={this.state.waiting} />
        {this.renderCommonComponent()}
      </View>
    );
  }

  renderBottom() {
    if (this.state.images.length > 0) {
      return (
        <View>
          <TouchableOpacity
            style={[componentStyles.editButtonWraper, { width: wp(30) }]}
            onPress={() => {
              this.setState({
                galleryModal: true,
                selectedImage: this.state.images[0].link,
              });
            }}
          >
            <TextView
              style={{
                color: "white",
                fontSize: 11,
                textAlign: "center",
                margin: 2,
              }}
            >
              {this.state.images[0].title}
            </TextView>
          </TouchableOpacity>
        </View>
      );
    } else {
      return <View />;
    }
  }

  normalUI() {
    return (
      <View style={{ flex: 1 }}>
        <View style={appStyles.toolbarWraper}>
          {!this.state.showSession &&
          this.state.info_order != null &&
          (this.state.info_order.status_order === "arrived" ||
            this.state.info_order.status_order === "getservant") ? (
            <TouchableOpacity
              style={appStyles.row}
              onPress={() => {
                this.setState({
                  reasonModal: true,
                });
              }}
            >
              <Image
                source={icons["cancel"]}
                style={[
                  appStyles.toolbarIcon,
                  { marginRight: 10, width: 15, height: 15 },
                ]}
              />
              <TextView style={{ fontSize: 12 }}>لغو سفارش</TextView>
            </TouchableOpacity>
          ) : (
            <View />
          )}
          <TextView
            style={{
              textAlign: "center",
              color: darkColor,
              fontSize: 12,
            }}
          >
            {this.state.info_order.title_service}
          </TextView>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.goBack();
            }}
          >
            <Image source={icons["back"]} style={appStyles.backIcon} />
          </TouchableOpacity>
        </View>
        <View
          style={[
            requestInfoStyles.infoWraper,
            {
              overflow: "hidden",
              paddingBottom: 10,
            },
            this.state.showSession &&
            this.state.info_order.status_order === "getservant"
              ? { maxHeight: hp(70) }
              : { maxHeight: hp(90) },
          ]}
        >
          <ScrollView>
            <View style={{ width: wp(88) }}>
              {!this.state.showSession ? (
                <FlatList
                  data={this.state.order_details}
                  ListHeaderComponent={this.renderNormalHeader.bind(this)}
                  renderItem={this.renderOrderRow.bind(this)}
                  ListFooterComponent={this.renderBottom.bind(this)}
                  keyExtractor={this._keyExtractor}
                />
              ) : (
                <FlatList
                  data={this.state.order_details[0].sessions}
                  ListHeaderComponent={this.renderNormalHeader.bind(this)}
                  renderItem={this.renderSessionRow.bind(this)}
                  ListFooterComponent={this.renderBottom.bind(this)}
                  keyExtractor={this._keyExtractor}
                />
              )}
            </View>
          </ScrollView>
        </View>
        {this.state.showSession &&
        this.state.info_order.status_order === "getservant" ? (
          <View
            style={[appStyles.bottomView, appStyles.shadow, appStyles.center]}
          >
            <TouchableOpacity
              activeOpacity={0.5}
              onPress={() => {
                this.setState({
                  showStartSession: true,
                });
              }}
            >
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={[blueLightColor, blueDarkColor]}
                style={[
                  componentStyles.gradinatButton,
                  {
                    width: wp(60),
                    borderRadius: hp(8) / 2,
                    height: hp(8),
                  },
                ]}
              >
                <TextView style={componentStyles.requestText}>
                  برو به لوکیشن مددجو
                </TextView>
                <Image
                  source={icons["target"]}
                  style={{
                    width: wp(8),
                    height: wp(8),
                    resizeMode: "contain",
                    marginRight: 15,
                  }}
                />
              </LinearGradient>
            </TouchableOpacity>
          </View>
        ) : null}
        <Waiting waiting={this.state.waiting} />
        {this.renderCommonComponent()}
      </View>
    );
  }

  preFactorUI() {
    return (
      <View style={{ flex: 1 }}>
        <View style={appStyles.toolbarWraper}>
          {!this.state.showSession &&
          this.state.info_order != null &&
          (this.state.info_order.status_order === "arrived" ||
            this.state.info_order.status_order === "getservant") ? (
            <TouchableOpacity
              style={appStyles.row}
              onPress={() => {
                this.setState({
                  reasonModal: true,
                });
              }}
            >
              <Image
                source={icons["cancel"]}
                style={[
                  appStyles.toolbarIcon,
                  { marginRight: 10, width: 15, height: 15 },
                ]}
              />
              <TextView style={{ fontSize: 12 }}>لغو سفارش</TextView>
            </TouchableOpacity>
          ) : (
            <View />
          )}
          <TextView style={appStyles.toolbarTitle}>رسید نهایی</TextView>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.goBack();
            }}
          >
            <Image source={icons["back"]} style={appStyles.backIcon} />
          </TouchableOpacity>
        </View>
        <LinearGradient
          colors={[blueDarkColor, blueLightColor]}
          style={[profileStyles.wraper, { height: hp(94) }]}
        >
          <View style={[orderInfoStyles.boxWraper, { flexDirection: "row" }]}>
            <FlatList
              data={this.state.order_details}
              ListHeaderComponent={this.renderPreOrderHeader.bind(this)}
              renderItem={this.renderPreOrderRow.bind(this)}
              ListFooterComponent={this.renderFooter.bind(this)}
              keyExtractor={this._keyExtractor}
            />
          </View>
          <View style={[appStyles.bottomView, appStyles.center]}>
            <Button
              style={customerLocationStyles.button}
              text={this.state.showSession ? "شروع جلسه اول" : "تایید و ادامه"}
              textStyle={customerLocationStyles.buttonText}
              showArrow={true}
              onPress={() => {
                if (this.state.showSession) {
                  this.setState({
                    waiting: true,
                  });
                  startSessionRequest(
                    this.state.currentSession.id_session,
                    (isConnect, response) => {
                      this.setState({
                        waiting: false,
                      });
                      if (isConnect && response.isSuccess) {
                        this.setState({
                          waiting: true,
                        });
                        this.getData();
                      } else {
                        showMessage("", getError(response));
                      }
                    }
                  );
                } else {
                  hamradRequest(
                    this.props.route.params.data.id,
                    "no",
                    (isConnect, response) => {
                      this.setState({
                        waiting: true,
                      });
                      this.getData();
                    }
                  );
                }
              }}
            />
          </View>
        </LinearGradient>
        <Waiting waiting={this.state.waiting} />
        {this.renderCommonComponent()}
      </View>
    );
  }

  renderCommonComponent() {
    return (
      <View>
        {this.state.currentSession != null ? (
          <DialogPrompt
            show={this.state.showStartSession}
            message={
              "آیا قصد انجام جلسه " +
              getNumber(this.state.currentSession.session_number) +
              " را دارید ؟ "
            }
            approve="بلی"
            cancel="خیر"
            onApprove={() => {
              this.setState(
                {
                  showStartSession: false,
                  waiting: true,
                },
                () => {
                  startSessionRequest(
                    this.state.currentSession.id_session,
                    (isConnect, response) => {
                      if (isConnect && response.isSuccess) {
                        this.setState({
                          waiting: true,
                        });
                        this.getData();
                      } else {
                        this.setState({
                          waiting: false,
                        });
                        showMessage("", getError(response));
                      }
                    }
                  );
                }
              );
            }}
            onCancel={() => {
              this.setState({
                showStartSession: false,
              });
            }}
            onClose={() => {
              this.setState({
                showStartSession: true,
              });
            }}
          />
        ) : null}
        {this.state.currentSession != null ? (
          <DialogPrompt
            show={this.state.showEndSession}
            message={
              "آیا شما جلسه " +
              getNumber(this.state.currentSession.session_number) +
              " را به پایان رساندید؟ "
            }
            approve="بلی"
            cancel="خیر"
            onApprove={() => {
              this.setState(
                {
                  showEndSession: false,
                  waiting: false,
                },
                () => {
                  setTimeout(() => {
                    this.setState({
                      rateModal: true,
                    });
                  }, 200);
                }
              );
            }}
            onCancel={() => {
              this.setState({
                showEndSession: false,
              });
            }}
            onClose={() => {
              this.setState({
                showEndSession: true,
              });
            }}
          />
        ) : null}

        <Modal
          visible={this.state.askModal}
          animationType="fade"
          transparent={true}
          onRequestClose={() => {
            this.setState({
              askModal: false,
            });
          }}
        >
          <TouchableWithoutFeedback
            onPress={() => {
              this.setState({
                askModal: true,
              });
            }}
          >
            <View style={appStyles.modalMessageAbsolute}>
              <View style={appStyles.modalMessageContent}>
                {/* <TextView style={{ marginBottom: 10, textAlign: 'center' }}>هر ۱۵ دقیقه یکبار پرسیده خواهد شد</TextView> */}
                <TextView
                  style={{ fontSize: 20, textAlign: "center", margin: 10 }}
                >
                  آیا شرایط برای انجام خدمت مساعد است؟
                </TextView>
                <View
                  style={[
                    appStyles.rowAround,
                    { marginTop: 20, marginBottom: 20 },
                  ]}
                >
                  <TouchableOpacity
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      backgroundColor: redColor,
                      justifyContent: "center",
                      alignItems: "center",
                      height: 40,
                      borderRadius: 20,
                      width: 80,
                      marginLeft: 20,
                    }}
                    onPress={() => {
                      this.setState({
                        waiting: true,
                        askModal: false,
                      });
                      askConditionRequest(
                        this.props.route.params.data.id,
                        "no",
                        (isConnect, response) => {
                          this.setState({
                            waiting: false,
                          });
                          if (isConnect && response.isSuccess) {
                          }
                        }
                      );
                    }}
                  >
                    <TextView style={{ color: "white", textAlign: "center" }}>
                      خیر
                    </TextView>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      backgroundColor: greenDarkColor,
                      justifyContent: "center",
                      alignItems: "center",
                      height: 40,
                      borderRadius: 20,
                      width: 80,
                      marginLeft: 20,
                    }}
                    onPress={() => {
                      this.setState({
                        waiting: true,
                        askModal: false,
                      });
                      askConditionRequest(
                        this.props.route.params.data.id,
                        "yes",
                        (isConnect, response) => {
                          this.setState({
                            waiting: false,
                          });
                          if (isConnect && response.isSuccess) {
                          }
                        }
                      );
                    }}
                  >
                    <TextView style={{ color: "white", textAlign: "center" }}>
                      بلی
                    </TextView>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </TouchableWithoutFeedback>
        </Modal>
        <DialogPrompt
          show={this.state.showHamrad}
          message="آیا به همراد نیاز دارید؟"
          approve="بلی"
          cancel="خیر"
          onApprove={() => {
            this.setState(
              {
                showHamrad: false,
                waiting: true,
              },
              () => {
                if (this.state.showSession) {
                  hamradSessionRequest(
                    this.state.currentSession.id_session,
                    "yes",
                    (isConnect, response) => {
                      this.setState({
                        waiting: false,
                      });
                      if (isConnect && response.isSuccess) {
                        this.setState({
                          waiting: true,
                        });
                        this.getData();
                      }
                    }
                  );
                } else {
                  hamradRequest(
                    this.props.route.params.data.id,
                    "yes",
                    (isConnect, response) => {
                      this.setState({
                        waiting: false,
                      });
                      if (isConnect && response.isSuccess) {
                        this.setState({
                          waiting: true,
                        });
                        this.getData();
                      }
                    }
                  );
                }
              }
            );
          }}
          onCancel={() => {
            this.setState(
              {
                showHamrad: false,
                waiting: true,
              },
              () => {
                if (this.state.showSession) {
                  hamradSessionRequest(
                    this.state.currentSession.id_session,
                    "no",
                    (isConnect, response) => {
                      this.setState({
                        waiting: false,
                      });
                      if (isConnect && response.isSuccess) {
                        this.setState({
                          waiting: true,
                        });
                        this.getData();
                      }
                    }
                  );
                } else {
                  hamradRequest(
                    this.props.route.params.data.id,
                    "no",
                    (isConnect, response) => {
                      this.setState({
                        waiting: false,
                      });
                      if (isConnect && response.isSuccess) {
                        this.setState({
                          waiting: true,
                        });
                        this.getData();
                      }
                    }
                  );
                }
              }
            );
          }}
          onClose={() => {
            this.setState({
              showHamrad: true,
            });
          }}
        />

        <Modal
          visible={this.state.reasonModal}
          animationType="fade"
          transparent={true}
          onRequestClose={() => {
            this.setState({
              reasonModal: false,
            });
          }}
        >
          <TouchableWithoutFeedback
            onPress={() => {
              this.setState({
                reasonModal: false,
              });
            }}
          >
            <View style={appStyles.modalMessageAbsolute}>
              <View style={orderInfoStyles.modalReasonContent}>
                <TextView style={{ fontSize: 20, marginBottom: 20 }}>
                  دلایل لغو سفارش چیست ؟
                </TextView>
                <View style={orderInfoStyles.lineDark} />
                <View
                  style={{
                    width: wp(90),
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FlatList
                    data={this.state.reasons}
                    style={{ width: wp(90) }}
                    numColumns={2}
                    keyExtractor={this._keyExtractor}
                    renderItem={this.renderReasonRow.bind(this)}
                  />
                </View>
                <View style={orderInfoStyles.lineDark} />
                <View
                  style={[
                    appStyles.rowAround,
                    { marginTop: 20, marginBottom: 20 },
                  ]}
                >
                  <TouchableOpacity
                    style={[
                      appStyles.outlineButton,
                      {
                        height: 40,
                        minWidth: 100,
                        width: 100,
                        alignSelf: "center",
                      },
                    ]}
                    onPress={() => {
                      this.setState({
                        reasonModal: false,
                      });
                    }}
                  >
                    <TextView style={{ color: "#C0C0C0", textAlign: "center" }}>
                      بستن
                    </TextView>
                  </TouchableOpacity>
                  <Button
                    text="لغو سفارش"
                    style={{
                      paddingLeft: 10,
                      paddingRight: 10,
                      height: 40,
                      borderRadius: 20,
                      width: 100,
                      marginLeft: 20,
                    }}
                    textStyle={[loginStyles.buttonText, { fontSize: 14 }]}
                    onPress={() => {
                      this.setState({
                        reasonModal: false,
                        waiting: true,
                      });
                      var reasons = "";
                      this.state.selectedReason.map((it) => {
                        if (reasons.length > 0) {
                          reasons += "," + it.id;
                        } else {
                          reasons = "" + it.id;
                        }
                      });
                      cancelOrderRequest(
                        this.props.route.params.data.id,
                        reasons,
                        (isConnect, response) => {
                          if (isConnect && response.isSuccess) {
                            this.props.route.params.onRefresh();
                            this.props.navigation.goBack();
                          } else {
                            showMessage("", getError(response));
                          }
                        }
                      );
                    }}
                  />
                </View>
              </View>
            </View>
          </TouchableWithoutFeedback>
        </Modal>
        <Modal
          visible={this.state.galleryModal}
          animationType="fade"
          transparent={true}
          onRequestClose={() => {
            this.setState({
              galleryModal: false,
            });
          }}
        >
          <TouchableWithoutFeedback
            onPress={() => {
              this.setState({
                galleryModal: false,
              });
            }}
          >
            <View style={appStyles.modalMessageAbsolute}>
              <View style={{ justifyContent: "center", alignItems: "center" }}>
                <ImageZoom
                  ref={(ref) => (this.imagezoom = ref)}
                  cropWidth={wp(100)}
                  cropHeight={hp(100)}
                  imageWidth={wp(100)}
                  imageHeight={hp(100)}
                >
                  <Image
                    source={{ uri: this.state.selectedImage }}
                    style={{
                      width: wp(100),
                      height: hp(100),
                      resizeMode: "contain",
                    }}
                  />
                </ImageZoom>
              </View>
              <TouchableOpacity
                style={{
                  position: "absolute",
                  top: 15,
                  right: 5,
                  backgroundColor: "white",
                  borderRadius: 5,
                }}
                onPress={() => {
                  this.setState({
                    galleryModal: false,
                  });
                }}
              >
                <Image
                  source={icons["back"]}
                  style={{
                    width: 20,
                    height: 20,
                    margin: 10,
                    resizeMode: "contain",
                  }}
                />
              </TouchableOpacity>
            </View>
          </TouchableWithoutFeedback>
        </Modal>

        <Modal
          visible={this.state.rateModal}
          animationType="fade"
          transparent={true}
          onRequestClose={() => {
            this.setState({
              rateModal: false,
            });
          }}
        >
          <TouchableWithoutFeedback
            onPress={() => {
              this.setState({
                rateModal: false,
              });
            }}
          >
            <View style={appStyles.modalMessageAbsolute}>
              <TouchableWithoutFeedback onPress={() => {}}>
                <View style={orderInfoStyles.modalReasonContent}>
                  <TextView
                    style={{ fontSize: 20, marginBottom: 20, marginTop: 20 }}
                  >
                    آیا از این بیمار راضی هستید ؟
                  </TextView>

                  <View
                    style={{
                      width: wp(80),
                      height: hp(5),
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-around",
                      borderBottomColor: "#F8F8F8",
                      borderBottomWidth: 1,
                    }}
                  >
                    <TouchableOpacity
                      style={[
                        {
                          height: hp(5),
                          width: wp(35),
                          justifyContent: "center",
                          alignItems: "center",
                        },
                        this.state.satisfy === "no"
                          ? {
                              borderBottomWidth: 2,
                              borderBottomColor: "#B9B9B9",
                            }
                          : null,
                      ]}
                      onPress={() => {
                        this.setState({
                          satisfy: "no",
                        });
                      }}
                    >
                      <TextView style={{ color: "#FF6555" }}>
                        خیر ، راضی نیستم
                      </TextView>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[
                        {
                          height: hp(5),
                          width: wp(35),
                          justifyContent: "center",
                          alignItems: "center",
                        },
                        this.state.satisfy === "yes"
                          ? {
                              borderBottomWidth: 2,
                              borderBottomColor: "#B9B9B9",
                            }
                          : null,
                      ]}
                      onPress={() => {
                        this.setState({
                          satisfy: "yes",
                        });
                      }}
                    >
                      <TextView style={{ color: "#31CF75" }}>
                        بله ، راضی هستم
                      </TextView>
                    </TouchableOpacity>
                  </View>

                  <EditText
                    hint="توضیحات خود را بنویسید"
                    multiline={true}
                    textStyle={{ color: "black", width: wp(80) }}
                    style={[
                      appStyles.textInput,
                      {
                        marginTop: 20,
                        marginBottom: 20,
                        width: wp(80),
                        minHeight: hp(10),
                      },
                    ]}
                    onChangeText={(text) => {
                      this.setState({
                        comment: text,
                      });
                    }}
                    value={this.state.comment}
                  />
                  <View
                    style={[
                      appStyles.rowAround,
                      { marginTop: 20, marginBottom: 20 },
                    ]}
                  >
                    <TouchableOpacity
                      style={[
                        appStyles.outlineButton,
                        {
                          height: 40,
                          minWidth: 100,
                          width: 100,
                          alignSelf: "center",
                        },
                      ]}
                      onPress={() => {
                        this.setState({
                          rateModal: false,
                        });
                      }}
                    >
                      <TextView
                        style={{ color: "#C0C0C0", textAlign: "center" }}
                      >
                        بستن
                      </TextView>
                    </TouchableOpacity>
                    <Button
                      text="ثبت نظر"
                      style={{
                        paddingLeft: 10,
                        paddingRight: 10,
                        height: 40,
                        borderRadius: 20,
                        width: 100,
                        marginLeft: 20,
                      }}
                      textStyle={[loginStyles.buttonText, { fontSize: 14 }]}
                      onPress={() => {
                        this.setState({
                          rateModal: false,
                          waiting: true,
                        });
                        if (
                          this.state.showSession &&
                          this.state.currentSession != null
                        ) {
                          endSessionRequest(
                            this.state.currentSession.id_session,
                            (isConnect, response) => {
                              if (isConnect && response.isSuccess) {
                                rateOrderRequest(
                                  this.props.route.params.data.id,
                                  this.state.satisfy,
                                  this.state.comment,
                                  (isConnect, response) => {
                                    if (isConnect && response.isSuccess) {
                                      this.getData();
                                    } else {
                                      this.setState({
                                        waiting: false,
                                      });
                                      showMessage("", getError(response));
                                    }
                                  }
                                );
                              } else {
                                this.setState({
                                  waiting: false,
                                });
                                showMessage("", getError(response));
                              }
                            }
                          );
                        } else {
                          endOrderRequest(
                            this.props.route.params.data.id,
                            (isConnect, response) => {
                              if (isConnect && response.isSuccess) {
                                rateOrderRequest(
                                  this.props.route.params.data.id,
                                  this.state.satisfy,
                                  this.state.comment,
                                  (isConnect, response) => {
                                    if (isConnect && response.isSuccess) {
                                      this.getData();
                                    } else {
                                      this.setState({
                                        waiting: false,
                                      });
                                      showMessage("", getError(response));
                                    }
                                  }
                                );
                              } else {
                                this.setState({
                                  waiting: false,
                                });
                                showMessage("", getError(response));
                              }
                            }
                          );
                        }
                      }}
                    />
                  </View>
                </View>
              </TouchableWithoutFeedback>
            </View>
          </TouchableWithoutFeedback>
        </Modal>
      </View>
    );
  }

  toggle() {
    let initialValue = this.state.expanded
        ? this.state.maxHeight + this.state.minHeight
        : this.state.minHeight,
      finalValue = this.state.expanded
        ? this.state.minHeight
        : this.state.maxHeight + this.state.minHeight;
    this.setState({
      expanded: !this.state.expanded,
    });
    this.state.animation.setValue(initialValue);
    Animated.spring(this.state.animation, {
      toValue: finalValue,
    }).start();
  }

  componentWillMount() {
    this.getData();
    reasonsRequest((isConnect, response) => {
      if (isConnect && response.isSuccess) {
        this.setState({
          reasons: response.data,
        });
      }
    });
  }

  componentDidMount() {
    AppState.addEventListener("change", this._handleAppStateChange);
  }

  componentWillUnmount() {
    AppState.removeEventListener("change", this._handleAppStateChange);
    clearInterval(this.intervalId);
  }

  _handleAppStateChange = (nextAppState) => {
    if (
      this.state.appState.match(/inactive|background/) &&
      nextAppState === "active"
    ) {
      this._startAutoPlay();
    } else {
      clearInterval(this.intervalId);
    }
    this.setState({ appState: nextAppState });
  };

  _startAutoPlay() {
    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.getData();
    }, 5000);
  }

  getData() {
    getMyOrderInfoRequest(
      this.props.route.params.data.id,
      (isConnect, response) => {
        this.setState({
          waiting: false,
        });
        if (isConnect && response.isSuccess) {
          this.props.route.params.onRefresh();
          var showSession = false;
          var isfirstSession = true;
          var currentSession = null;
          let askModal;
          if (
            response.data.order_details != null &&
            response.data.order_details.length > 0
          ) {
            if (
              response.data.order_details[0].sessions != null &&
              response.data.order_details[0].sessions.length > 0
            ) {
              showSession = true;
              var startedSession =
                response.data.order_details[0].sessions.filter(
                  (it) =>
                    it.status_servant === "start" ||
                    it.status_servant === "arrived"
                );
              if (startedSession != null && startedSession.length > 0) {
                currentSession = startedSession[0];
              }
              response.data.order_details[0].sessions.map((it) => {
                if (it.status_servant != null) {
                  isfirstSession = false;
                }
                if (it.status_servant == null && currentSession == null) {
                  currentSession = it;
                }
              });
            }
            var images = [];
            response.data.order_details.map((item) => {
              if (
                item.typefield === "image" &&
                item.textfield != null &&
                item.textfield.length > 0
              ) {
                images.push({ link: item.textfield, title: item.topicfield });
              }
            });
            this.setState({
              images: images,
            });
          }
          if (
            response.data.info_order != null &&
            (response.data.info_order.status_order === "getservant" ||
              response.data.info_order.status_order === "arrived")
          ) {
            if (response.data.info_order.status_order === "getservant") {
              if (
                currentSession != null &&
                currentSession.status_servant === "arrived"
              ) {
                askModal = true;
              }
            } else if (response.data.info_order.status_order === "arrived") {
              askModal = true;
            }
          }
          // if (askModal) {
          //     clearInterval(this._timerId)
          //     this._timerId = setInterval(() => this.setState({
          //         askModal: true
          //     }), 900000)
          // }
          this.setState({
            showSession: showSession,
            isfirstSession: isfirstSession,
            currentSession: currentSession,
            info_order: response.data.info_order,
            info_servant:
              (!Array.isArray(response.data.info_servant) &&
                response.data.info_servant != null) ||
              (Array.isArray(response.data.info_servant) &&
                response.data.info_servant.length > 0)
                ? response.data.info_servant
                : null,
            order_details: response.data.order_details,
            customer: [
              parseFloat(response.data.info_order.lng),
              parseFloat(response.data.info_order.lat),
            ],
            expert:
              (!Array.isArray(response.data.info_servant) &&
                response.data.info_servant != null) ||
              (Array.isArray(response.data.info_servant) &&
                response.data.info_servant.length > 0)
                ? [
                    parseFloat(response.data.info_servant.lng),
                    parseFloat(response.data.info_servant.lat),
                  ]
                : [0, 0],
          });
          if (
            response.data.info_order.status_order === "getservant" ||
            response.data.info_order.status_order === "arrived"
          ) {
            this.getCurrentPosition();
          }
          this._startAutoPlay();
        }
      }
    );
  }

  getCurrentPosition() {
    (async () => {
      try {
        let { status } = await Location.requestPermissionsAsync();
        if (status !== "granted") {
          showMessage("", "Permission to access location was denied");
          return;
        }
        let location = await Location.getCurrentPositionAsync({});

        this.setState({
          expert: [location.coords.longitude, location.coords.latitude],
          latitude: location.coords.latitude,
          longitude: location.coords.longitude,
        });
      } catch (e) {
        alert(e.message || "");
      }
    })();
  }
}
